import { fork } from "redux-saga/effects";
import authSaga from "../../feature/auth/authSaga";
import trackingLinkSaga from "../../feature/tracking-links/trackingLinkSaga";
import referralPartnerSaga from "../../feature/referral-partners/referralPartnerSaga";
import partnerTrackingSaga from "../../feature/partner-tracking/partnerTrackingSaga";
import partnerDetailsSaga from "../../feature/partner-details/partnerDetailsSaga";
import partnerApprovalSaga from "../../feature/partner-approval/partnerApprovalSaga";

function* rootSaga() {
  yield fork(authSaga);
  yield fork(trackingLinkSaga);
  yield fork(referralPartnerSaga);
  yield fork(partnerTrackingSaga);
  yield fork(partnerDetailsSaga);
  yield fork(partnerApprovalSaga);
}

export default rootSaga;
